import { TStoreApi, TContainerProps, IUser, IPicture } from '../common/types';
import { Theme } from '@unfold/theme';

const setAuthenticated = (status: boolean) => ({ setState }: TStoreApi): void => {
  setState((draft) => {
    draft.authenticated = status;
  });
};

const setLoading = (status: boolean) => ({ setState }: TStoreApi): void => {
  setState((draft) => {
    draft.loading = status;
  });
};

const setUploading = (status: boolean) => ({ setState }: TStoreApi): void => {
  setState((draft) => {
    draft.uploading = status;
  });
};

const setLoginErrorMessage = (message: string) => ({ setState }: TStoreApi): void => {
  setState((draft) => {
    draft.loginErrorMessage = message
  })
}

export const actions = {
  getUser: () => async (
    { setState, dispatch }: TStoreApi,
    { api }: TContainerProps
  ): Promise<void> => {
    dispatch(setLoading(true));
    let userData: IUser;
    let pictureData: IPicture;
    try {
      ({ data: userData } = await api.get('/api/v1/info/me'));
      ({ data: pictureData } = await api.get(
        '/api/v1/brands/profile-picture'
      ));
    }
    catch(error) {
      dispatch(setLoading(false));
      return;
    }
    setState((draft) => {
      draft.user = { ...userData, profilePicture: pictureData.ref };
    });

    dispatch(setLoading(false));
  },
  setBrandName: (data: { name: string }) => async (
    { setState }: TStoreApi,
    { api }: TContainerProps
  ): Promise<void> => {
    await api.put('/api/v1/brands/name', data);

    setState((draft) => {
      if (draft.user) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        draft.user.brand_name = data.name;
      }
    });
  },
  setBrandHandle: (data: { handle: string }) => async (
    { setState }: TStoreApi,
    { api }: TContainerProps
  ): Promise<void> => {
    await api.put('/api/v1/brands/handle', data);

    setState((draft) => {
      if (draft.user) {
        // eslint-disable-next-line @typescript-eslint/camelcase
        draft.user.brand_handle = data.handle;
      }
    });
  },
  setTheme: (theme: Theme) => async ({
    setState,
  }: TStoreApi): Promise<void> => {
    setState((draft) => {
      draft.theme = theme;
    });
  },
  setProfilePicture: (file: File) => async (
    { setState, dispatch }: TStoreApi,
    { api }: TContainerProps
  ): Promise<void> => {
    const formData = new FormData();
    formData.append('data-file', file);

    dispatch(setUploading(true));
    const { data: pictureData } = await api.post(
      '/api/v1/brands/profile-picture',
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
    );
    setState((draft) => {
      if (draft.user) {
        draft.user.profilePicture = pictureData.ref as string;
      }
    });
    dispatch(setUploading(false));
  },

  removeProfilePicture: () => async (
    { setState }: TStoreApi,
    { api }: TContainerProps
  ): Promise<void> => {
    await api.delete('/api/v1/brands/profile-picture');
    setState((draft) => {
      if(draft.user) {
        draft.user.profilePicture = '';
      }
    });
  },

  login: () => async (
    { setState }: TStoreApi,
  ): Promise<void> => {
    window.location.href = `${process.env.API_BASE_URL}/api/v1/auth/login?signin=true`
  },

  logout: () => async (
    { setState }: TStoreApi,
    { api }: TContainerProps,
  ): Promise<void> => {
    await api.get('/api/v1/auth/logout');
    localStorage.removeItem('token');
    delete api.defaults.headers.common['Authorization'];
    location.reload();
  },

  addToken: (token: string) => (
    { dispatch }: TStoreApi,
    { api }: TContainerProps,
  ): void => {
    localStorage.setItem('token', token);
    api.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${localStorage.getItem('token')}`;
    dispatch(setAuthenticated(true));
  },

  removeToken: () => (
    { dispatch }: TStoreApi,
    { api }: TContainerProps,
  ): void => {
    localStorage.removeItem('token');
    delete api?.defaults.headers.common['Authorization'];
    dispatch(setAuthenticated(false));
  },

  init: () => (
    { dispatch }: TStoreApi,
  ): void => {
    // Check for existing auth token
    const hasToken = !!localStorage.getItem('token');
    dispatch(setAuthenticated(hasToken));
  },

  setAuthError: (error: string) => (
    { dispatch }: TStoreApi,
  ): void => {
    dispatch(setLoginErrorMessage(error))
  }
};

export type TActions = typeof actions;
